export default __webpack_public_path__ + "static/materiaMedica-c1d04f97bffb6ba307edda1c1f363e61.svg";